import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import CardNew from "components/molecules/Card/CardNew";
import usePermissions from "hooks/usePermissions";
import ReportType from "./ReportType";
import ReportForm from "./components/ReportForm/ReportForm";
import ReportTypeSelector from "./components/ReportTypeSelector/ReportTypeSelector";

import "./Report.scss";

interface NewReportProps {
  onSuccess: () => void;
  onCancel: () => void;
}

/**
 * New Report component. Renders the report type selector and the report form.
 */
function NewReport({ onSuccess, onCancel }: NewReportProps): JSX.Element {
  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      start_date: null,
      end_date: null,
      teams: null,
      shippers: null,
      freight_modes: [],
      group_by: "request_date",
    },
  });
  const { permissions } = usePermissions();
  const userType = permissions && JSON.parse(permissions).user_type;
  const defaultSelectedReportType = userType === "shipper" ? ReportType.QUICK_REQUEST : ReportType.QUOTES;

  const [selectedReportType, setSelectedReportType] = useState<ReportType>(defaultSelectedReportType);

  return (
    <FormProvider {...methods}>
      <div>
        <CardNew className="border-radius-top-0">
          <ReportTypeSelector selectedReportType={selectedReportType} setSelectedReportType={setSelectedReportType} />
        </CardNew>
        <div style={{ marginTop: "16px" }}>
          <ReportForm selectedReportType={selectedReportType} onSuccess={onSuccess} onCancel={onCancel} />
        </div>
      </div>
    </FormProvider>
  );
}

export default NewReport;
